import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { Loader } from "../components/common";
import MessageThread from "../components/MessageThread";

export default function CoachMessages() {
  const location = useLocation();
  const [convos, setConvos] = useState(null);
  const [active, setActive] = useState(location.state?.conversationId || null);

  useEffect(() => {
    api.get("/conversations").then(({ data }) => {
      setConvos(data);
      if (!active && data.length) setActive(data[0].id);
    });
  }, []);
  if (!convos) return <Loader />;

  const activeConv = convos.find((c) => c.id === active);

  return (
    <div className="flex h-[calc(100vh-56px)] lg:h-screen">
      <div className="w-72 border-r border-border overflow-y-auto hidden md:block">
        <div className="p-4 border-b border-border"><h1 className="font-heading text-3xl">Messages</h1></div>
        {convos.map((c) => (
          <button key={c.id} data-testid={`convo-${c.id}`} onClick={() => setActive(c.id)} className={`w-full flex items-center gap-3 p-3 text-left border-b border-white/5 hover:bg-white/5 ${active === c.id ? "bg-white/5" : ""}`}>
            <div className="w-10 h-10 rounded-full bg-brand/20 flex items-center justify-center font-heading text-brand">{c.participant?.name?.[0]}</div>
            <div className="flex-1 min-w-0"><p className="font-semibold text-sm truncate">{c.participant?.name}</p><p className="text-xs text-tertiary truncate">{c.last_message}</p></div>
            {c.unread > 0 && <span className="bg-brand text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center font-bold">{c.unread}</span>}
          </button>
        ))}
      </div>
      <div className="flex-1 flex flex-col min-w-0">
        {/* mobile selector */}
        <div className="md:hidden p-2 border-b border-border overflow-x-auto flex gap-1">
          {convos.map((c) => <button key={c.id} onClick={() => setActive(c.id)} className={`px-3 py-1.5 rounded-lg text-xs whitespace-nowrap ${active === c.id ? "bg-brand text-white" : "card-surface text-secondary"}`}>{c.participant?.name}</button>)}
        </div>
        {activeConv ? <MessageThread conversationId={activeConv.id} headerName={activeConv.participant?.name} headerPic={activeConv.participant?.picture} /> : <div className="flex-1 flex items-center justify-center text-tertiary">Select a conversation</div>}
      </div>
    </div>
  );
}
